/**
 * Main store function
 */
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension'

import rootReducer from './reducers';

export function configureStore(initialState = {}) {
     // Middleware and store enhancers
     const enhancers = [applyMiddleware(thunk)];

     const composedEnhancers = composeWithDevTools(compose(...enhancers))

     const store = createStore(
          rootReducer,
          initialState,
          composedEnhancers
     );
     return store;
}